import { Col, DesignTokens, Row, Space, Title } from "melco-ui";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { parseAPIErrorResponse } from "melco-shared-logic";
import { useValidateLogin } from "../../hooks/login/useValidateLogin";
import { DisplayErrors } from "../helper/DisplayErrors";
import MelcoAccountFlowLayout from "../layout/MelcoAccountFlowLayout";
import { useLogin } from "../../hooks/login/useLogin";
import { DisplayMachineStatusViewGroupsAndMachies } from "./DisplayMachineStatusViewGroupsAndMachines";

type MachineStatusViewProps = {
  view: any;
  access_token: string;
  password: string;
};

const { spacings } = DesignTokens;

export const MachineStatusView: React.FC<MachineStatusViewProps> = ({
  view,
  access_token,
  password,
}) => {
  const { t } = useTranslation();
  const validateLogin = useValidateLogin();
  const login = useLogin();
  const [messages, setMessages] = useState<string[]>([]);
  const socketRef = useRef<WebSocket | null>(null);
  const [lastDataReceivedTime, setLastDataReceivedTime] = useState(Date.now());
  const [visible, setVisible] = useState(false);
  const [viewDetail, setViewDetail] = useState(view);

  const [refLastUpdatedViewDateTime, setRefLastUpdatedViewDateTime] = useState(
    new Date()
  );
  const [errors, setErrors] = useState<any[]>();

  //Effect to check inactivity condition
  const checkValidToken = async () => {
    let validateLoginResponse = undefined;
    try {
      validateLoginResponse = await validateLogin({
        access_token: access_token,
      });
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);
      setErrors(apiErrors);
    } finally {
      return validateLoginResponse;
    }
  };

  const refreshLoginLogic = async () => {
    console.log("refreshLoginLogic");
    let loginResponse = undefined;
    try {
      loginResponse = await login({
        password: password,
        access_token,
        view_id: viewDetail?.id,
      });
    } catch (error) {
      const apiErrors = await parseAPIErrorResponse(error);
      setErrors(apiErrors);
    } finally {
      setViewDetail(loginResponse);
      return;
    }
  };

  const refreshLogin = async (updatedDate: any) => {
    console.log("refreshLogin");
    console.log(updatedDate);
    if (
      new Date(updatedDate).toISOString() >
      refLastUpdatedViewDateTime.toISOString()
    ) {
      refreshLoginLogic();
      setRefLastUpdatedViewDateTime(new Date(updatedDate));
    } else {
      console.log("Lesser");
    }
  };

  useEffect(() => {
    const checkInactivity = () => {
      const currentTime = Date.now();
      if (currentTime - lastDataReceivedTime > 5 * 60000) {
        // 5 minute
        setVisible(true);
      }
    };

    const interval = setInterval(checkInactivity, 5000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [lastDataReceivedTime]);

  useEffect(() => {
    const connect = (url: string) => {
      console.log("ws - connect");
      console.log(url);
      socketRef.current = new WebSocket(url);

      socketRef.current.onmessage = (event: any) => {
        // alert("incoming message");
        setMessages((prevMessages) => [...prevMessages, event.data]);
      };

      socketRef.current.onclose = (e: any) => {
        console.log(
          "ws - Socket is closed. Reconnect will be attempted in 1 second."
        );
        setTimeout(function () {
          connect(url);
        }, 1000);
      };

      socketRef.current.onerror = (err: any) => {
        console.log(
          "ws - Socket encountered error: ",
          err.message,
          "ws - Closing socket"
        );
        socketRef?.current?.close();
      };
    };

    fetch(
      `https://castleapi.nicecoast-f6e97df0.centralus.azurecontainerapps.io/api/iot/machines/subscribe`,
      {
        method: "POST",
        headers: {
          "x-api-key": "3a0777b2823b47c94aa4f64cc016fc34",
          "x-customer-id": "676008190",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          deviceIds: ["96ba76ac-5b63-4c5c-87e8-c532073220f3"],
        }),
      }
    ).then(async (response) => {
      const result = (await response.json()) as {
        url: string;
        deviceIds: string[];
      };

      connect(result.url);
    });
  }, []);

  useEffect(() => {
    // Need to get latest data as if we reload the /view page, it goes through routing and takes old data
    refreshLoginLogic();

    const checkForReloadPage = async () => {
      console.log("checkForReloadPage");
      let validateLoginResponse = await checkValidToken();

      let updatedDate = validateLoginResponse?.updated_date ?? undefined;

      if (!updatedDate) {
        return null;
      }

      refreshLogin(updatedDate);
    };
    const interval = setInterval(checkForReloadPage, 5 * 60 * 1000); // Check every 5 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {/* <div>
          <button
            onClick={() => {
              socketRef.current?.close();
            }}
          >
            {" "}
            disconnect
          </button>
          {messages.map((msg, index) => (
            <div key={index}>{msg}</div>
          ))}
        </div> */}
      {errors && errors.length > 0 && (
        <MelcoAccountFlowLayout>
          <Space direction="vertical" size="xlarge">
            <>{<DisplayErrors errors={errors} />}</>
          </Space>
        </MelcoAccountFlowLayout>
      )}
      {!errors && (
        <div>
          <Row gutter={[spacings.middle, spacings.middle]}>
            <Col xs={24} md={12} xl={12}>
              <div style={{ marginLeft: "15px" }}>
                <Title level={3}>{viewDetail.name}</Title>
              </div>
            </Col>
          </Row>
          <DisplayMachineStatusViewGroupsAndMachies viewDetail={viewDetail} />
        </div>
      )}
    </>
  );
};
